import React from 'react';
import { Container, Title, Text, Card, Group, Button, List, Grid, Box, Image } from '@mantine/core';
import DocumentCard from '../components/DocumentCard';

const Sadhana = () => (
  <div style={{
    background: 'linear-gradient(180deg, var(--cream) 0%, var(--linen) 100%)',
    minHeight: '80vh',
    padding: '3rem 0'
  }}>
    {/* Sadhana Resources Section - Moved to Top */}
    <Container size="lg" mb="4rem">
      <Group justify="space-between" align="center" mb="2rem" wrap="wrap">
        <Title
          order={2}
          style={{
            fontSize: '2rem',
            color: 'var(--charcoal)',
            fontFamily: 'Georgia, serif',
            fontWeight: 700
          }}
        >
          Sadhana Resources
        </Title>

        <Text
          size="lg"
          style={{
            color: 'var(--terracotta-medium)',
            lineHeight: 1.6,
            fontStyle: 'italic'
          }}
        >
          Download or view these sacred texts and songs to support your practice
        </Text>
      </Group>

      <Grid gutter="xl" justify="center">
        {/* Jap Ji Column */}
        <Grid.Col span={{ base: 12, md: 6, lg: 5 }}>
          <DocumentCard
            documentKey="japJi"
            title="Jap Ji Sahib & Sohila"
            description="The foundational morning prayer of Sikh Dharma and the evening prayer. Contains the essence of all spiritual teachings recited during our practice."
          />
        </Grid.Col>

        {/* Aquarian Sadhana Mantras Column */}
        <Grid.Col span={{ base: 12, md: 6, lg: 5 }}>
          <DocumentCard
            documentKey="kirtanSongs"
            title="Aquarian Sadhana Mantras"
            description="Sacred mantras and devotional songs from the Aquarian Sadhana. These healing sounds elevate consciousness and create spiritual connection."
          />
        </Grid.Col>
      </Grid>
    </Container>

    {/* Amrit Vela Sadhana Section with Image */}
    <Container size="lg" mb="4rem">
      <Grid gutter="xl">
        {/* Image Column - 1/3 */}
        <Grid.Col span={{ base: 12, md: 4 }}>
          <Box style={{ textAlign: 'center' }}>
            <Image
              src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
              alt="Amrit Vela meditation practice"
              style={{
                width: '100%',
                height: '300px',
                objectFit: 'cover',
                borderRadius: '16px',
                border: '3px solid var(--saffron-bright)',
                boxShadow: '0 8px 24px rgba(244, 196, 48, 0.3)'
              }}
            />
          </Box>
        </Grid.Col>

        {/* Content Column - 2/3 */}
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Title
            order={2}
            mb="lg"
            style={{
              fontSize: '2.2rem',
              color: 'var(--charcoal)',
              fontFamily: 'Georgia, serif',
              fontWeight: 700
            }}
          >
            Amrit Vela Sadhana
          </Title>
          <Text
            size="lg"
            mb="xl"
            style={{
              color: 'var(--terracotta-medium)',
              lineHeight: 1.6,
              fontSize: '1.1rem'
            }}
          >
            Join us for the sacred early morning practice. Amrit Vela, the "ambrosial hours" before dawn,
            is the most powerful time for spiritual practice. Experience transformation through this
            2.5-hour journey of consciousness.
          </Text>
          
          <Title order={3} mb="md" c="var(--terracotta-medium)">What to Expect:</Title>
          <List spacing="md" size="md" mb="xl">
            <List.Item>
              <Text c="var(--charcoal)"><strong style={{ color: 'var(--saffron-bright)' }}>4:00 AM Start:</strong> Begin when the world is quiet and energy is pure</Text>
            </List.Item>
            <List.Item>
              <Text c="var(--charcoal)"><strong style={{ color: 'var(--saffron-bright)' }}>Jap Ji,</strong> Guru Nanak's (the founder of Sikhism) Cosmic Poetry</Text>
            </List.Item>
            <List.Item>
              <Text c="var(--charcoal)"><strong style={{ color: 'var(--saffron-bright)' }}>Movement:</strong> Kundalini yoga and meditation practices</Text>
            </List.Item>
            <List.Item>
              <Text c="var(--charcoal)"><strong style={{ color: 'var(--saffron-bright)' }}>Kirtan:</strong> Devotional chanting and music</Text>
            </List.Item>
          </List>
        </Grid.Col>
      </Grid>
    </Container>
  </div>
);

export default Sadhana;
